import React, {useState} from "react";
import { RxDoubleArrowDown } from "react-icons/rx";
import {faGoogle, faYelp , faInstagram} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {Fade, Slide} from "react-awesome-reveal";
import videoIntro from "../img/background.mp4";
import img1 from "../img/1.png";
import img2 from "../img/bg2.png";
import img3 from "../img/review.png";
import SwiperReview from "../Components/SwiperReview";
import GallerySwiper from "../Components/GallerySwiper";
import Menu from "../img/Menu.png";
import Popup from "../Components/Popup";


export default function Home(){

    function scrollSec(){
        const home1 = document.getElementById('Home1');
        home1?.scrollIntoView({
            behavior:"smooth"
        });
    };

    const [isOpen, setIsOpen] = useState(false);

    return (
        <main className=" relative overflow-hidden">
            
            <section className="">
                <video playsInline = "true" src={videoIntro} loop="true" muted="true" autoPlay="autoplay" className='object-cover absolute h-screen w-screen -z-10 top-0 left-0'></video>
                <div className="bg-black py-5 flex flex-col items-center bg-opacity-30 h-screen w-screen justify-between tracking-wide text-white">
                    <div className=" flex flex-col h-screen justify-center">
                        <div className=" !font-serif space-y-8 text-center ">
                            <div className="">
                                <button onClick = {() =>
                                    window.open("https://maps.app.goo.gl/uuecJaWrUTHV3TMh8" , '__blank')
                                } className="hover:shadow-lg font-serif text-white hover:-translate-y-2 hover:bg-main-color hover:text-white ease-in-out delay-100 duration-150 text-2xl border-2 border-main-color py-4 w-[300px] mt-12 group cursor-pointer md:tracking-wide">
                                    <span className="">Get Direction</span>
                                </button>
                            </div>
                            <div className=" flex lg:hidden justify-center space-x-5">
                                <div onClick={() => {
                                    window.location.href= 'https://www.instagram.com/creasian.lonetree?utm_source=qr';
                                }} className=" cursor-pointer ease-in-out delay-100 duration-150 hover:bg-black/60 flex justify-center items-center shadow-xl px-4 py-2 bg-white rounded-full">
                                    <FontAwesomeIcon className=" w-[22px] h-[22px] text-rose-300" icon={faInstagram} />
                                </div>
                                <div onClick={() => {
                                    window.location.href= 'https://maps.app.goo.gl/NRvhLSGgFTFyAkk89';
                                }} className=" cursor-pointer ease-in-out delay-100 duration-150 hover:bg-black/60 flex justify-center items-center shadow-xl px-4 py-2 bg-white rounded-full">
                                    <FontAwesomeIcon className=" w-[22px] h-[22px] text-green-400" icon={faGoogle} />
                                </div>
                                <div onClick={() => {
                                    window.location.href= 'https://www.yelp.com/biz/cre-asian-flavors-of-vietnam-brentwood';
                                }} className="cursor-pointer ease-in-out delay-100 duration-150 hover:bg-black/60 flex justify-center items-center shadow-xl px-4 py-2 bg-white rounded-full">
                                    <FontAwesomeIcon className=" w-[22px] h-[22px] text-rose-400" icon={faYelp} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="p-4 flex justify-center items-center">
                        <button onClick={() => scrollSec()} className="group ">
                            <RxDoubleArrowDown className="ease-in-out delay-100 duration-150 group-hover:-translate-y-2 group-hover:text-main-color text-5xl" />
                        </button>
                    </div>
                </div>
            </section>

            <section className=" bg-bg1 lg:bg-top lg:bg-cover bg-no-repeat"  id="Home1">
                <div className=" pt-6 pb-8 lg:pt-24 lg:pb-24 space-y-4">
                    <div className="lg:p-4 p-2 mx-auto max-w-screen-xl">
                        <div className=" grid gap-8 lg:gap-12 place-items-center lg:grid-cols-2">
                            <div className="lg:p-4 lg:hidden flex w-full">
                                <img alt="test" className=" cursor-pointer w-full" src={img1} />
                            </div>
                            <div className=" flex space-y-3 lg:space-y-8 flex-col capitalize text-center">
                                <Slide duration={1000} direction="down">
                                    <span className=" lg:text-2xl text-xl text-black font-PlayFair">About us</span>
                                    <div className=" flex flex-col space-y-4">
                                        <span className="lg:text-4xl text-3xl font-header-font text-gray-400">
                                            Blending Tradition with Modern
                                        </span>
                                        <span className="text-6xl text-main-color font-Freehand">
                                            Flavors
                                        </span>
                                    </div>
                                    <p className="lg:text-xl text-lg mx-2 text-black font-txt-font">
                                        At CreAsian, we bring the vibrant flavors of Vietnam to Brentwood, California. 
                                        Our menu features authentic dishes like Traditional Beef Noodle Soup (Phở), 
                                        flavorful Stir-Fried meals, and refreshing Mango Shrimp Salad. Every dish is made with
                                        fresh, high-quality ingredients, ensuring an unforgettable dining experience. 
                                        Join us and savor the true taste of Vietnam in a warm and welcoming atmosphere.                          
                                    </p>
                                    <div className="">
                                        <button onClick={() => setIsOpen(!isOpen)} className="hover:shadow-lg font-txt-font text-white lg:text-black border-2 bg-main-color lg:bg-white border-main-color hover:bg-main-color hover:-translate-y-2 hover:bg-main2 hover:text-white ease-in-out delay-100 duration-150 mt-5 md:text-xl text-lg py-3 px-12 group cursor-pointer md:tracking-wide">
                                            <span className="">Order Now</span>
                                        </button>
                                    </div>
                                </Slide>
                            </div>
                            <div className="lg:p-4 hidden lg:flex w-full">
                                <img alt="" className=" cursor-pointer hover:opacity-80 ease-in-out delay-100 duration-150 lg:h-[500px] w-full" src={img1} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className=" bg-bg1 bg-bottom lg:bg-cover bg-no-repeat">
                <div className=" pt-6 pb-8 lg:pb-24 space-y-4">
                    <div className="lg:p-4 p-2 mx-auto max-w-screen-xl">
                        <div className=" grid gap-8 lg:gap-12 place-items-center lg:grid-cols-2">
                            <div className=" w-full h-fit">
                                <img alt="" src={img2} />
                            </div>
                            <div className=" flex space-y-3 lg:space-y-8 flex-col capitalize text-center">
                                <Slide duration={1000} direction="down">
                                    <span className=" lg:text-2xl text-xl text-black font-PlayFair">Our Menu</span>
                                    <div className=" flex flex-col space-y-4">
                                        <span className="text-4xl text-main-color font-Freehand">
                                            Taste of Vietnam
                                        </span>
                                    </div>
                                    <p className="lg:text-xl text-lg mx-2 text-black font-txt-font">
                                        Discover a vibrant selection of authentic Vietnamese dishes, 
                                        from savory Phở and flavorful Stir-Fried meals to refreshing Salads and Chef’s Specials. 
                                        Our menu is crafted with fresh, high-quality ingredients, bringing the true taste of Vietnam to
                                        Brentwood, California.                         
                                    </p>
                                    <div className="">
                                        <button onClick={() => 
                                            window.open(Menu , '__blank')
                                        } className="hover:shadow-lg font-txt-font text-white lg:text-black border-2 bg-main-color lg:bg-white border-main-color hover:bg-main-color hover:-translate-y-2 hover:bg-main2 hover:text-white ease-in-out delay-100 duration-150 mt-5 md:text-xl text-lg py-3 px-12 group cursor-pointer md:tracking-wide">
                                            <span className="">View Menu</span>
                                        </button>
                                    </div>
                                </Slide>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
            <Fade delay={500}>
                <section className=" bg-bgsmall bg-bottom lg:bg-cover bg-no-repeat">
                    <div className=" pt-6 pb-8 lg:pb-12 space-y-4">
                        <div className="lg:p-4 p-2 mx-auto max-w-screen-xl">
                            <div className=" grid gap-4 grid-cols-1 lg:grid-cols-2">
                                <div className=" w-full group cursor-pointer h-fit">
                                    <img alt="" className=" group-hover:opacity-70" src={img3} />
                                </div>
                                <div className="p-2 flex items-center">
                                    <SwiperReview />
                                </div>
                            </div>
                            <div className=" flex mt-6 justify-center">
                                <button onClick={() => 
                                        window.open("https://maps.app.goo.gl/uuecJaWrUTHV3TMh8" , '__blank')
                                    } className="hover:shadow-lg font-txt-font text-white lg:text-black border-2 bg-main-color lg:bg-white border-main-color hover:bg-main-color hover:-translate-y-2 hover:bg-main2 hover:text-white ease-in-out delay-100 duration-150 mt-5 md:text-xl text-lg py-3 px-12 group cursor-pointer md:tracking-wide">
                                    <span className="">View More</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </section>
            </Fade>

            <section className=" bg-white">
                <div className="">
                    <div className="lg:p-4 p-2 mx-auto max-w-screen-xl">
                        <GallerySwiper />
                    </div>
                </div>
            </section>


            {isOpen &&
                <Popup isOpen={isOpen} setIsOpen={setIsOpen} />
            }

        </main>
    )
}